import Svg, { Path } from 'react-native-svg';
interface ShopIconNewProps {
  size?: number;
}

const ShopIconNew = ({ size = 32 }: ShopIconNewProps) => (
  <Svg
    width={size}
    height={(size * 21) / 24}
    viewBox="0 0 24 21"
    fill="none"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.5C0 1.39543 0.895431 0.5 2 0.5H21.1111C22.2157 0.5 23.1111 1.39543 23.1111 2.5V18.5C23.1111 19.6046 22.2157 20.5 21.1111 20.5H2C0.895433 20.5 0 19.6046 0 18.5V2.5Z"
      fill="#003349"
    />
    <Path
      d="M11.5557 6.9C11.5557 6.67909 11.7348 6.5 11.9557 6.5H19.1557C19.3766 6.5 19.5557 6.67909 19.5557 6.9V20.5H11.5557V6.9Z"
      fill="#F1F5F5"
    />
    <Path
      d="M2.85547 6.9C2.85547 6.67909 3.03455 6.5 3.25547 6.5H8.45547C8.67638 6.5 8.85547 6.67909 8.85547 6.9V12.5H2.85547V6.9Z"
      fill="#F1F5F5"
    />
  </Svg>
);

export default ShopIconNew;
